__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@monorepo/account-wrapper";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@monorepo/store/queryClient", "1.0.0", () => (Promise.all([__webpack_require__.e(707), __webpack_require__.e(596)]).then(() => (() => (__webpack_require__(596))))));
			register("@monorepo/store/useUserStore", "1.0.0", () => (Promise.all([__webpack_require__.e(359), __webpack_require__.e(188)]).then(() => (() => (__webpack_require__(188))))));
			register("@tanstack/react-query", "5.99.0", () => (Promise.all([__webpack_require__.e(460), __webpack_require__.e(359)]).then(() => (() => (__webpack_require__(4460))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(359)]).then(() => (() => (__webpack_require__(316))))));
			register("react", "18.3.1", () => (__webpack_require__.e(155).then(() => (() => (__webpack_require__(2155))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};